export class ApiError extends Error {
  status: number
  constructor(message: string, status: number) { super(message); this.status = status }
}

function message(data: unknown): string {
  if (typeof data === 'object' && data && 'detail' in data) {
    const detail = (data as { detail: unknown }).detail
    if (typeof detail === 'string') return detail
    if (Array.isArray(detail)) return detail.map((item) => typeof item === 'object' && item && 'msg' in item ? String(item.msg) : String(item)).join(', ')
  }
  return 'Something went wrong. Please try again.'
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const token = localStorage.getItem('aad_access_token')
  const headers = new Headers(options.headers)
  if (token) headers.set('Authorization', `Bearer ${token}`)
  if (options.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json')
  const response = await fetch(path, { ...options, headers })
  const text = await response.text()
  let data: unknown
  try { data = text ? JSON.parse(text) : null } catch { data = text }
  if (response.status === 401) {
    localStorage.removeItem('aad_access_token')
    localStorage.removeItem('aad_selected_business_id')
    window.location.assign('/login')
  }
  if (!response.ok) throw new ApiError(message(data), response.status)
  return data as T
}

export function businessPath(path: string) {
  const businessId = localStorage.getItem('aad_selected_business_id')
  if (!businessId) throw new ApiError('Select a business workspace first.', 400)
  return `/api/businesses/${businessId}${path}`
}

export const money = (value: unknown) => new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(Number(value ?? 0))
export const dateTime = (value: unknown) => value ? new Intl.DateTimeFormat('en-NG', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(String(value))) : '—'
